<template>
    <div class="coursePersonnel-list">
        <div class="manage-wrapper">
            <div class="table-wrapper">
                <h2 class="table-title">
                    <img src="../../assets/images/main/bulltin-icon.png" alt="" class="title-icon">学员详情</h2>
                <div class="export-btn csp" style="margin-right:10px" @click="exportFile"><i class="export-icon"></i>导出
                </div>
                <div class="table">
                    <el-table :data="tableData" border style="width: 100%">
                        <el-table-column type="index" label="序号" style="background:#2373EC" align="center">
                        </el-table-column>
                        <el-table-column prop="name" label="教师姓名" align="center"></el-table-column>
                        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                        <el-table-column prop="userAreaName" label="地区" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="schoolName" label="学校" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="liveTime" :label="'直播学习总时长\n(单位：秒)'" align="center"
                            v-if="$route.query.type == 0">
                            <template slot-scope="scope">
                                {{scope.row.liveTime?scope.row.liveTime:0}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="recordTime" :label="'观看回放总时长\n(单位：秒)'" align="center"
                            v-if="$route.query.type == 0">
                            <template slot-scope="scope">
                                {{scope.row.recordTime?scope.row.recordTime:0}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="recordTime" :label="'学习总时长\n(单位：秒)'" align="center"
                            v-if="$route.query.type == 1">
                            <template slot-scope="scope">
                                {{scope.row.recordTime?scope.row.recordTime:0}}
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
                        :limit.sync="pages.pageSize" @pagination="handlePageChange">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id: 89,
                pages: { //分页
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                tableData: [],
            }
        },

        methods: {
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.getUserStudyInfo();
            },
            async getUserStudyInfo() {
                let params = {
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                    lessonId: this.$route.params.id,
                }
                let resData = await this.$Api.Project.getUserStudyInfo(params);
                console.log(resData);
                this.tableData = resData.data.records
                this.pages.total = resData.data.total
            },
            async exportFile() {
                this.$message.info('正在导出...')
                window.location.href =
                    `${this.commonbaseURL}/score/projectHome/getUserStudyInfo/export?page=${this.pages.currentPage}&limit=${this.pages.pageSize}&lessonId=${this.$route.params.id}`;
            },
        },
        mounted() {
            this.getUserStudyInfo();
        }
    }
</script>

<style lang="less" scoped>
    @import "../manage/less/table.less";

    .coursePersonnel-list {

        .table-wrapper {
            border-radius: 8px;
            padding-top: 10px;
            background: #fff;
            padding: 0 26px 24px;
            box-shadow: 0px 2px 10px 0px #F5F8FA;
        }

        .table-title {
            line-height: 68px;
            font-size: 17px;
        }

        .export-btn {
            color: #595959;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;
        }

        .export-icon {
            display: inline-block;
            background-image: url("~@/assets/images/admin/export.png");
            background-size: 100% 100%;
            width: 17px;
            height: 16px;
            margin-right: 8px;
            vertical-align: -2px;
        }

        .title-icon {
            width: 21px;
            height: 21px;
            margin-right: 9px;
            vertical-align: -4px;
        }

        .table {
            /deep/.el-table th {
                &>.cell {
                    white-space: pre-line;
                }
            }
        }

        @media screen and (min-width:1250px) {
            .table-wrapper {
                padding: 0 43px 24px;
            }
        }
    }
</style>